
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import IndustriesSection from './components/IndustriesSection';
import AddOnsSection from './components/AddOnsSection';
import TestimonialSection from './components/TestimonialSection';
import FinalCTASection from './components/FinalCTASection';
import SEOHead from '../../components/SEOHead';

const Home: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Ligare A.I.",
    "description": "Deploy autonomous AI systems that automate lead generation, client management, and operations. Ligare A.I. creates intelligent business solutions with AI agents that work 24/7, customized for your industry.",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://ligare-ai.com'}`,
    "logo": `${import.meta.env.VITE_SITE_URL || 'https://ligare-ai.com'}/logo.png`,
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "English"
    },
    "sameAs": [],
    "service": [
      {
        "@type": "Service",
        "name": "Lead Generation AI",
        "description": "Intelligent systems that identify, qualify, and engage prospects automatically."
      },
      {
        "@type": "Service", 
        "name": "Process Automation",
        "description": "Streamline operations with intelligent workflow automation."
      },
      {
        "@type": "Service",
        "name": "Client Experience AI",
        "description": "Personalized interactions that build lasting relationships."
      }
    ]
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="Ligare A.I. - Intelligent Business Automation | AI Agent Services"
        description="Deploy autonomous AI systems that automate lead generation, client management, and operations. Ligare A.I. creates intelligent business solutions with AI agents that work 24/7, customized for your industry."
        keywords="AI agents, business automation, lead generation AI, process automation, client experience AI"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://ligare-ai.com'}/`}
        ogTitle="Ligare A.I. - Intelligent Business Automation"
        ogDescription="Deploy autonomous AI systems that automate lead generation, client management, and operations."
        structuredData={structuredData}
      />
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <IndustriesSection />
        <AddOnsSection />
        <TestimonialSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
